import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import {
  saveOrgUser,
} from '../../../stores/slices/organisations/organisationsActions';

const CoachModal = ({ isOpen, onOpen, onClose, toUpdate, getCoaches }) => {
  const schema = yup
    .object({
      firstName: yup.string().required('First mame is required'),
      lastName: yup.string().required('Last name is required'),
      active: yup.string().required('Active status is required'),
      email: yup
        .string()
        .email('Must be a valid email')
        .required('Email is required'),
      password: yup
        .string()
        .min(8, 'Must be at least 8 characters long')
        .required('Password is required'),
    })
    .required();

  const dispatch = useDispatch();
  const toast = useToast();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSave = async data => {
    let userData = {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      password: data.password,
      role: data.role,
      is_active: data.active
    };
    if (!toUpdate.state) {
      userData = { ...userData, role: 'coach' };
    }
    const res = await dispatch(
      saveOrgUser({
        data: userData,
        isUpdate: toUpdate,
      })
    );

    if (res.type === 'coaches/saveCoach/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      reset();
      getCoaches();
      onClose();
      toast({
        description: toUpdate.state
          ? 'Coach has been updated'
          : 'Coach has been created',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={() => {
        reset();
        onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit(onSave)}>
          <ModalHeader>{toUpdate.state ? 'Edit' : 'Add new'} coach</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={'2'}>
              <FormControl id="firstName" isInvalid={errors.firstName}>
                <FormLabel>First Name</FormLabel>
                <Input
                  id="firstName"
                  {...register('firstName')}
                  defaultValue={toUpdate.state ? toUpdate.user.first_name : ''}
                />
                <FormErrorMessage>
                  {errors.firstName && errors.firstName.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="lastName" isInvalid={errors.lastName}>
                <FormLabel>Last Name</FormLabel>
                <Input
                  id="lastName"
                  {...register('lastName')}
                  defaultValue={toUpdate.state ? toUpdate.user.last_name : ''}
                />
                <FormErrorMessage>
                  {errors.lastName && errors.lastName.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="email" isInvalid={errors.email}>
                <FormLabel>Email address</FormLabel>
                <Input
                  id="email"
                  {...register('email')}
                  defaultValue={toUpdate.state ? toUpdate.user.email : ''}
                />
                <FormErrorMessage>
                  {errors.email && errors.email.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="password" isInvalid={errors.password}>
                <FormLabel>Password</FormLabel>
                <Input
                  id="password"
                  type={'password'}
                  {...register('password')}
                />
                <FormErrorMessage>
                  {errors.password && errors.password.message}
                </FormErrorMessage>
                <FormHelperText>
                  Your password must be 8-20 characters long, contain letters
                  and numbers, and must not contain spaces, or emoji.
                </FormHelperText>
              </FormControl>
              <FormControl id="active" isInvalid={errors.active}>
                <FormLabel>Active</FormLabel>
                <Select
                  placeholder="Select option"
                  id="active"
                  {...register('active')}
                  defaultValue={toUpdate.state ? toUpdate.user.is_active : ''}
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </Select>
                <FormErrorMessage>
                  {errors.active && errors.active.message}
                </FormErrorMessage>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} type="submit" isLoading={isSubmitting}>
              Save
            </Button>
            <Button
              onClick={() => {
                reset();
                onClose();
              }}
              variant="outline"
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default CoachModal;
